<div class="performance-container">
  <div class="pc-performance-table-stack">
  <div class="detail-rail-table-wrapper pc-performance-table-wrapper">
  <div class="table-view-banner view-active table-view-banner--in-shell">
    <mat-icon>directions_boat</mat-icon>
    <div class="banner-copy">
      <span class="banner-title">Fleet View</span>
    </div>
    <span class="banner-count">{{ elements?.length || 0 }} records</span>
  </div>
  <div
    class="detail-rail-table-scroll table-container scroll-bar pc-performance-table-scroll pc-data-table"
    [class.pc-data-table--dark]="isDarkMode()"
  >
    <table
      class="pc-performance-table mat-elevation-z8 printable-table"
      #table
      id="style-4"
      matSort
      [ngClass]="{ 'dark-table': isDarkMode() }"
    >
      <thead class="sticky-header">
        <tr>
          <th class="th-text-centersno centersno" mat-sort-header="sNo">
            S.No
          </th>
          <!-- <th class="th-text-center printView" rowspan="2">Ship View</th> -->
          <th
            class="fixed-head th-text-center3"
            mat-sort-header="vessel_name"
          >
            Ship Name
          </th>

          <th class="th-text-center2" mat-sort-header="vessel_imo">
            I.M.O Number
          </th>

          <th class="th-text-center" mat-sort-header="segment">
            Segment
          </th>

          <th>
            <span class="header-show info1">
              Performance Against warranties(MT)
              <mat-icon class="info" matTooltip="loss in red gain in green"
                >info</mat-icon
              >
            </span>
          </th>
          <th>
            <span class="header-show info1">
              Performance Against Design(MT)
              <mat-icon class="info" matTooltip="loss in red gain in green"
                >info</mat-icon
              >
            </span>
          </th>
          <th mat-sort-header="claimAmount">
            <span class="header-show info1">
              Claimable Amount as per Charter Party($)
              <mat-icon
                class="info"
                matTooltip="Negative = Under Performance, Positive = Over Performance"
                >info</mat-icon
              >
            </span>
          </th>
        </tr>
        <!-- <tr>
          <th class="th-text-center2" mat-sort-header="hsfo">
            <span>Maneuvering</span>
          </th>
          <th class="th-text-center2" mat-sort-header="vlsfo">
            <span>Idle</span>
          </th>
          <th class="th-text-center2" mat-sort-header="go">
            <span>Cargo operation</span>
          </th>
        </tr> -->
      </thead>

      <tbody>
        <tr *ngFor="let element of paginatedData; let rowIndex = index">
          <td class="centersno">
            {{ rowIndex + 1 }}
          </td>

          <!-- <td>
            <button
              class="gradient-btn"
              [ngStyle]="{
                'background-image': 'linear-gradient(98deg, #0046de, #006063)',
                'border-radius': '11px',
                border: 'none',
              }"
            >
              <mat-icon
                fontSet="material-icons-outlined"
                fontIcon="visibility"
                class="visiblityIcon"
                >visibility_outlined</mat-icon
              >
            </button>
          </td> -->

          <td class="fixed-col">{{ formatVesselName(element.vessel_name) }}</td>
          <td>{{ element.vessel_imo }}</td>
          <td>
            <span [ngStyle]="getDynamicSegmentStyle(element.segment)">
              {{ formatSegment(element.segment) }}
            </span>
          </td>

          <!-- Bunker Loss or Gain -->
          <td
            [ngStyle]="getWarrantedStyle(element)"
            [matTooltip]="getWarrantedTooltip(element)"
            [matTooltipClass]="tooltipClass"
            matTooltipPosition="above"
          >
            {{ element.performance_against_warranties.toFixed(2) }}
          </td>
          <td
            [ngStyle]="getTotalDesignStyle(element)"
            [matTooltip]="getDesignTooltip(element)"
            [matTooltipClass]="tooltipClass"
            matTooltipPosition="above"
          >
            {{ element.performance_against_design.toFixed(2) }}
          </td>

          <!-- Claimable Amount -->
          <td style="cursor: pointer">
            {{ element.claimable_amount }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  </div>
  </div>
</div>
